import React, { Component } from 'react';
import RegExpHelper from '../../../../../Common/Helpers/RegExpHelper';
import InputDefecto from '../../../../../Common/Components/InputDefecto';
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';

class LimiteCompraCabal extends Component {
    constructor(props) {
        super(props);

        //this.onLimiteCompraCabalChange = this.onLimiteCompraCabalChange.bind(this);
        this.state = {
            limiteCompraCabalMin: props.data.limiteCompraCabalMin,
            limiteCompraCabalMax: props.data.limiteCompraCabalMax,
            limiteCompraCabalDefault: props.data.limiteCompraCabalDefault
        };
    }

    onLimiteCompraCabalChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);
        /*Antes de actualizar cualquier cosa, valido que se haya presionado el boton*/
        //if (this.props.data.LimiteCompraCabal) {
        if (regExp.test(value) || value.replace(/\s/g, "", "") == "") {
            let newState = {
                [dataset.code]: value
            }

            if (dataset.code == "limiteCompraCabalMin") {
                newState = {
                    ...newState,
                    limiteCompraCabalDefault: value
                }
            }

            this.setState(newState);
        }
        //}


    }

    onLimiteCompraCabalBlur(event) {
        const { value, dataset } = event.target;
        this.props.changeInput(dataset.code, value);
        if (dataset.code == "limiteCompraCabalMin") {
            this.props.changeInput("limiteCompraCabalDefault",value)
            
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            limiteCompraCabalMin: nextProps.data.limiteCompraCabalMin,
            limiteCompraCabalMax: nextProps.data.limiteCompraCabalMax,
            limiteCompraCabalDefault: nextProps.data.limiteCompraCabalDefault
        });
    }

    render() {
        const { onLimiteCompraCabalChange, onLimiteCompraCabalBlur } = this;
        let { data, form, changeInput, selectCheckBox } = this.props;

        let pattern0to1000000000 = RegExpHelper.Pattern0to1000000000();
        let acentoLetraAminuscula = ExpHelper.ConvertirCaracter("a");
        let acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");
        let errorLimites
        let errorLimiteDefault

        if(this.state.limiteCompraCabalMin != "" && this.state.limiteCompraCabalMax != "" && this.state.limiteCompraCabalDefault != ""){
            errorLimites =  !(parseInt(this.state.limiteCompraCabalMin) <= parseInt(this.state.limiteCompraCabalMax)) 
            if(!errorLimites){
                errorLimiteDefault = !(parseInt(this.state.limiteCompraCabalDefault) >= parseInt(this.state.limiteCompraCabalMin) && parseInt(this.state.limiteCompraCabalDefault) <= parseInt(this.state.limiteCompraCabalMax))
            }
        }


        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"L" + acentoLetraIminuscula + "mite de Compra"}</label>
                    <div className="container-radio radio-margin">
                        <div className="row">
                            <div className="col-xs-3"><label className="lbl-radio label-secondary">{"M" + acentoLetraIminuscula + "nimo $"}</label></div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={10}
                                    value={this.state.limiteCompraCabalMin}
                                    data-code="limiteCompraCabalMin"
                                    data-validation="^(?=.*[1-9])\d{0,9}?$"
                                    onChange={onLimiteCompraCabalChange.bind(this)}
                                    onBlur={onLimiteCompraCabalBlur.bind(this)}
                                />
                            </div>

                            <div className="col-xs-2" style={{position: 'relative', right: '28px'}}><label className="lbl-radio label-secondary">{"M" + acentoLetraAminuscula + "ximo $"}</label></div>

                            <div className="col-xs-2" style={{ position: 'relative', right: '87px' }}>
                                <input className="form-control"
                                    maxLength={10}
                                    value={this.state.limiteCompraCabalMax}
                                    data-code="limiteCompraCabalMax"
                                    data-validation="^(?=.*[1-9])\d{0,9}?$"
                                    onChange={onLimiteCompraCabalChange.bind(this)}
                                    onBlur={onLimiteCompraCabalBlur.bind(this)}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-3">
                                <label className="lbl-radio label-secondary">{"L" + acentoLetraIminuscula + "mite de compra por defecto"}</label>
                            </div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={10}
                                    value={this.state.limiteCompraCabalDefault}
                                    data-code="limiteCompraCabalDefault"
                                    data-validation="^(?=.*[1-9])\d{0,9}?$"
                                    onChange={onLimiteCompraCabalChange.bind(this)}
                                    onBlur={onLimiteCompraCabalBlur.bind(this)}
                                />
                            </div>
                        </div>

                        <div className="lbl-radio">
                            <CheckDefecto
                                check={data.limiteCompraCabalDefaultInterfaz}
                                referencia={"limiteCompraCabalCheck"}
                                selectCheckBox={({ target }) => selectCheckBox("limiteCompraCabalDefaultInterfaz", target.checked)}
                            />
                        </div>
                {(data.ERROR_PRODUCT["limiteCompraCabalMax"] == false && errorLimites )? <label className="error">El límite inferior debe ser menor o igual al límite superior.</label> : null}
                {(data.ERROR_PRODUCT["limiteCompraCabalMax"] == false && errorLimiteDefault )? <label className="error">El valor por defecto debe estar entre el límite inferior y superior.</label> : null}
                {data.ERROR_PRODUCT["limiteCompraCabalMax"] == false && !errorLimites && !errorLimiteDefault ? <label className="error">Debe ingresar un Límite de Compra.</label> : null}
                    </div>
                </div>


            </div>
        );
    }
};

export default LimiteCompraCabal;